import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import Spinner from '../components/commons/Spinner'
import { ActivarEq, FinalizarEq, NoFinalizarEq } from '../components/EqInOt/FinalizarEq'
import { Canceleq } from '../components/Equipo/Canceleq'
import { Editareq } from '../components/Equipo/Editareq'
import { Observacioneq } from '../components/Equipo/Observacioneq'
import { Modales } from '../components/Modales'
import { Modalcarga } from '../components/Modales/Modalcarga'
import { Otdatacliente } from '../components/Ot/Otdatacliente'
import { Otsonpdf } from '../components/Ot/Otsonpdf'
import { PARENT } from '../constants'
import { useAuth } from "../hooks/useAuth"
import HojasTrabajo from '../components/Aprobar/HojasTrabajo'
import { AprobarAll, AprobarSeleccion, DesaprobarSeleccion } from '../components/EqInOt/AprobarSelect'
import DateProgram from '../components/Ot/DateProgram'
import { HojasDeTrabajo } from '../components/Seguimiento/HojasTrabajo'
import { EqFinalizadosTotal } from '../components/Ot/EqFinalizados'
import { ContadoresOt } from '../components/Ot/IndicadoresOt'
import Cabecera from '../components/Ot/Cabecera'
import AgregarEquiposOt from '../components/Ot/AgregarEquiposOt'
import useOtLogicLegacy from '../components/OtSelect/useOtLogicLegacy'
import TableEquiposCompact from '../components/OtSelect/TableEquiposCompact'
import ToolbarActionsResponsive from '../components/OtSelect/ToolbarActionsResponsive'
import ModalRegistrarMovimiento from '../components/Finanzas/ModalRegistrarMovimiento'
import ModalConfirmarAccionPareja from '../components/Ot/ModalConfirmarAccionPareja'
import useAccionParejaOt from '../hooks/useAccionParejaOt'
import { getBolsilloMio } from '../api/finanzas'
import ModalConfirmarEntrega from '../components/Prestamos/ConfrimarEntrega'
import NuevaSalida from '../components/SalidaEntradaPatrones/NuevaSalida'
import DetalleMovimiento from '../components/SalidaEntradaPatrones/DetalleMovimiento'
import { movimientosByOtId, getVisitaVigente } from '../api/common'
import { Alertassw } from '../components/Alertas/Alertassw'
import ModalHojasTrabajo from '../components/OtSelect/ModalHojasTrabajo'
import ModalReprogramar from '../components/Programaciones/ModalReprogramar'
import HojasTrabajoList from '../components/HojaTrabajo/HojasTrabajoList'


export const Otselect = () => {
  // Auth
  const userData = useAuth()
  const result = userData.userData
  
  // Route params
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const task = searchParams.get('task')
  const source = searchParams.get('source')
  
  // Custom hook para gestión de OT (reemplaza variables globales)
  const { 
    ots, 
    setOt, 
    equiposOtIni, 
    setEquiposOtIni, 
    sedes, 
    setSedes, 
    modalcharge, 
    SetModalcharge, 
    toggleRefresh,
    error 
  } = useOtLogicLegacy({ id, searchParams })
  
  // Estado local para UI
  const [estadomodal, setEstadomodal] = useState(false)
  const [equipoinfo, setEquipoinfo] = useState({})
  const [sedeSeleted, setSedeSeleted] = useState()
  const [historialeq, setHistorialEq] = useState()
  const [sitioSeleted, setSitioSeleted] = useState()
  const [optionAproved, setOptionAproved] = useState()
  const [selectAll, setSelectAll] = useState(false)
  const [accion, setAccion] = useState({
    tarea: '',
    titulo: ''
  })
  
  
  // Estados para nuevas funcionalidades
  const [onGastoModal, setOnGastoModal] = useState(false);
  const [bolsilloMio, setBolsilloMio] = useState(null);
  const [mostrarModalConfirmar, setMostrarModalConfirmar] = useState(false);
  const [mostrarModalSalidaEntrada, setMostrarModalSalidaEntrada] = useState(false);
  const [mostrarModalDetalle, setMostrarModalDetalle] = useState(false);
  const [movimientoDetalleData, setMovimientoDetalleData] = useState(null);
  
  // Modal de Hojas de Trabajo
  const [showModalHT, setShowModalHT] = useState(false);
  const [cacheHT, setCacheHT] = useState(null);

  // Movimientos de patrones activos para esta OT (para badge de cobertura)
  const [movimientosActivos, setMovimientosActivos] = useState([]);
  const [patronIdsActivos, setPatronIdsActivos] = useState(new Set());

  // Visita vigente para esta OT
  const [visitaVigente, setVisitaVigente] = useState(undefined); // undefined=cargando, null=no hay
  const [showReprogramar, setShowReprogramar] = useState(false);

  const fetchVisitaVigente = useCallback(() => {
    if (!ots?._id) return;
    
    getVisitaVigente({ otId: ots._id })
      .then(r => setVisitaVigente(r.data.visita || null))
      .catch(() => setVisitaVigente(null));
  }, [ots?._id]);

  useEffect(() => {
    fetchVisitaVigente();
  }, [fetchVisitaVigente]);

  useEffect(() => {
    if (!ots?._id) return;
    const today = new Date();
    movimientosByOtId(ots._id)
      .then(res => {
        if (res.status === 200 && Array.isArray(res.data?.data)) {
          const activos = res.data.data.filter(m => {
            if (m.status !== 'open') return false;
            if (m.dueDate && new Date(m.dueDate) < today) return false;
            return true;
          });
          setMovimientosActivos(activos);
          const ids = new Set(activos.map(m => m.patronId?._id || m.patronId).filter(Boolean));
          setPatronIdsActivos(ids);
        }
      })
      .catch(err => console.error('[Otselect] Error cargando movimientos patrones:', err));
  }, [ots?._id]);

  const reloadMovimientosActivos = useCallback(() => {
    if (!ots?._id) return;
    const today = new Date();
    movimientosByOtId(ots._id)
      .then(res => {
        if (res.status === 200 && Array.isArray(res.data?.data)) {
          const activos = res.data.data.filter(m => {
            if (m.status !== 'open') return false;
            if (m.dueDate && new Date(m.dueDate) < today) return false;
            return true;
          });
          setMovimientosActivos(activos);
          setPatronIdsActivos(new Set(activos.map(m => m.patronId?._id || m.patronId).filter(Boolean)));
        }
      })
      .catch(err => console.error('[Otselect] reload movimientos:', err));
  }, [ots?._id]);

  // useRef para selección múltiple (reemplaza global equiSelect)
  const equiSelectRef = useRef([])
  const [fakeState, setFakeState] = useState(false) // Para forzar re-render
  
  // Query para queryson_aprobar
  const queryson_aprobar = useCallback((orden) => ({
    conditions: {
      numeroOrden: orden,
      otType: PARENT,
    },
    fields: null,
    options: {
      limit: 1,
      sort: {
        visitas: -1
      }
    }
  }), [])
  
  // ============ FILTROS CON useMemo ============
  
  /**
   * Filtro por sitio (En Sitio vs En Instalaciones)
   */
  const EqSitioFilter = useMemo(() => {
    if (!sitioSeleted) return equiposOtIni
    
    return sitioSeleted === "Sitio" 
      ? equiposOtIni.filter(equipo => !equipo.fechaIngreso)
      : equiposOtIni.filter(equipo => equipo.fechaIngreso)
  }, [sitioSeleted, equiposOtIni])
  
  /**
   * Filtro por sede
   */
  const EqSedeFilter = useMemo(() => {
    if (!sedeSeleted) return EqSitioFilter
    
    return EqSitioFilter.filter(item => item?.equipo?.sedeClient?._id === sedeSeleted)
  }, [sedeSeleted, EqSitioFilter])
  
  /**
   * Filtro para equipos a finalizar (solo los del responsable actual)
   */
  const filtradoFinalizar = useMemo(() => {
    return EqSedeFilter?.filter((eqEnd) => 
      (eqEnd.estado === 'Procesado' || eqEnd.estado === 'Cancelado' || eqEnd.estado === 'Pendiente') && 
      eqEnd?.responsable?._id === result._id
    )
  }, [EqSedeFilter, result._id])
  
  // ============ HANDLERS CON useCallback ============
  
  /**
   * Finalizar equipo
   */
  const Finalizar = useCallback(async (eq) => {
    const equipoActualizado = await FinalizarEq(
      eq._id, 
      ots.numeroOrden, 
      ots.visitas, 
      SetModalcharge, 
      result
    )
    if (equipoActualizado) toggleRefresh()
  }, [ots, result, toggleRefresh])
  
  // Hook reutilizable para envolver acciones con consulta de pareja
  // (spec equipos-dependientes-sincronizacion-cancelacion). Compartido con OtSelectMain.js.
  const { envolverConPareja, modalAccionParejaProps } = useAccionParejaOt({
    otId: ots?._id,
    equiposOtIni,
  })

  /**
   * Ejecutor puro de Activar — sin consulta de pareja.
   */
  const ejecutarActivar = useCallback(async (eq) => {
    SetModalcharge(true)
    const equipoActualizado = await ActivarEq(
      eq._id,
      ots.numeroOrden,
      ots.visitas,
      SetModalcharge,
      result,
      ots,
      eq,
      queryson_aprobar
    )
    if (equipoActualizado) toggleRefresh()
  }, [ots, result, toggleRefresh, queryson_aprobar])

  /**
   * Activar envuelto — abre modal si el equipo tiene pareja en la OT.
   * excluirEstados: [] → incluye pareja cancelada (para restaurar juntos).
   */
  const Activar = useMemo(
    () => envolverConPareja({ handler: ejecutarActivar, accionLabel: 'activación', excluirEstados: [] }),
    [envolverConPareja, ejecutarActivar]
  )

  /**
   * Ejecutor puro de NoFinalizar.
   */
  const ejecutarNoFinalizar = useCallback(async (eq) => {
    const equipoActualizado = await NoFinalizarEq(eq._id, SetModalcharge, task)
    if (equipoActualizado) toggleRefresh()
  }, [task, toggleRefresh])

  const NoFinalizar = useMemo(
    () => envolverConPareja({ handler: ejecutarNoFinalizar, accionLabel: 'aplazamiento' }),
    [envolverConPareja, ejecutarNoFinalizar]
  )
  
  /**
   * Abrir modal adicionar ítems
   */
  const handleAddEquipment = useCallback(() => {
    setEstadomodal(true)
    setAccion({
      tarea: 'Adicionar Ítems',
      titulo: ''
    })
  }, [])
  
  /**
   * Abrir modales varios (HT, Finalizados, etc)
   */
  const handleHT = useCallback((tipo) => {
    if (tipo === 'Hojas de Trabajo') {
      setShowModalHT(true);
    } else {
      setEstadomodal(true)
      setAccion({
        tarea: tipo,
        titulo: tipo
      })
    }
  }, [])
  
  /**
   * Crear hoja de trabajo
   */
  const creteOt = useCallback(() => {
    setEstadomodal(true)
    setAccion({
      tarea: 'Hoja de Trabajo',
      titulo: `${ots.numeroOrden}-${ots.visitas}`
    })
  }, [ots])
  
  /**
   * Editar equipo
   */
  const Editequipo = useCallback((eq) => {
    setEquipoinfo(eq)
    setEstadomodal(true)
    setAccion({
      tarea: 'Editar',
      titulo: eq.equipo?.item?.nombre
    })
  }, [])
  
  /**
   * Ver observación
   */
  const observacion = useCallback((eq) => {
    setEquipoinfo(eq)
    setEstadomodal(true)
    setAccion({
      tarea: 'Observacion',
      titulo: eq.equipo?.item?.nombre
    })
  }, [])
  
  /**
   * Cancelar equipo
   */
  const Cancelareq = useCallback((eq) => {
    setEquipoinfo(eq)
    setEstadomodal(true)
    setAccion({
      tarea: 'Cancelar',
      titulo: eq.equipo?.item?.nombre
    })
  }, [])
  
  /**
   * Editar cliente
   */
  const Editcliente = useCallback((ots) => {
    setEstadomodal(true)
    setAccion({
      tarea: 'Editar Cliente',
      titulo: ots?.nombre
    })
  }, [])
  
  const handleGasto = useCallback(async () => {
    let bolsillo = bolsilloMio;
    if (!bolsillo) {
      try {
        const resp = await getBolsilloMio();
        bolsillo = resp?.data?.data?.bolsillo;
        if (!bolsillo) {
          Alertassw('warning', 'Sin bolsillo', 'No tienes un bolsillo asignado. Contacta al administrador.');
          return;
        }
        setBolsilloMio(bolsillo);
      } catch {
        Alertassw('error', 'Error', 'No se pudo cargar el bolsillo');
        return;
      }
    }
    setOnGastoModal(true);
  }, [bolsilloMio])
  
  /**
   * Abrir modal confirmar préstamo/entrega
   */
  const handleConfirmarPrestamo = useCallback(() => {
    setMostrarModalConfirmar(true)
  }, [])
  
  /**
   * Cerrar modal de préstamo
   */
  const handleCloseConfirmar = useCallback(() => {
    setMostrarModalConfirmar(false)
  }, [])
  
  /**
   * Abrir modal de salida de patrones
   * Verifica si existe un movimiento activo primero
   */
  const handleAbrirSalidaPatrones = useCallback(async () => {
    if (!ots?._id) return;
    if (movimientosActivos.length > 0) {
      Alertassw('toast', 'Movimiento Activo', `Grupo ${movimientosActivos[0].groupConsecutive} — abriendo detalle...`);
      setMovimientoDetalleData(movimientosActivos[0]);
      setMostrarModalDetalle(true);
    } else {
      setMostrarModalSalidaEntrada(true);
    }
  }, [ots?._id, movimientosActivos])
  
  /**
   * Cerrar modal de salida/entrada de patrones
   */
  const handleCloseSalidaEntrada = useCallback(() => {
    setMostrarModalSalidaEntrada(false)
    toggleRefresh()
    reloadMovimientosActivos()
  }, [toggleRefresh, reloadMovimientosActivos])
  
  /**
   * Cerrar modal de detalle de movimiento
   */
  const handleCloseDetalle = useCallback(() => {
    setMostrarModalDetalle(false)
    setMovimientoDetalleData(null)
    toggleRefresh()
    reloadMovimientosActivos()
  }, [toggleRefresh, reloadMovimientosActivos])
  
  /**
   * Select all checkbox (task revisar)
   */
  const AprobarAllCheck = useCallback((e) => {
    const checked = e.target.checked
    setSelectAll(checked)
    
    if (checked) {
      equiSelectRef.current = AprobarAll(EqSedeFilter)
    } else {
      equiSelectRef.current = []
    }
    
    setFakeState(s => !s) // Forzar re-render
  }, [EqSedeFilter])
  
  /**
   * Toggle checkbox individual (task revisar)
   */
  const AprobarOneCheck = useCallback((eq) => {
    if (!eq) return
    
    const exists = equiSelectRef.current.some(objeto => objeto._id === eq._id)
    
    if (exists) {
      equiSelectRef.current = equiSelectRef.current.filter(item => item._id !== eq._id)
    } else {
      equiSelectRef.current.push(eq)
    }
    
    setSelectAll(false)
    setFakeState(s => !s) // Forzar re-render
  }, [])
  
  /**
   * Aprobar selección múltiple
   */
  const handleAprobarSeleccion = useCallback(async () => {
    await AprobarSeleccion(
      equiSelectRef.current, 
      result, 
      ots.numeroOrden, 
      ots.visitas, 
      SetModalcharge, 
      toggleRefresh
    )
    equiSelectRef.current = []
    setSelectAll(false)
    setFakeState(s => !s)
  }, [result, ots, toggleRefresh])

  const ejecutarDesaprobar = useCallback(async (eq) => {
    await DesaprobarSeleccion([eq], SetModalcharge, toggleRefresh)
  }, [toggleRefresh])

  const handleDesaprobar = useMemo(
    () => envolverConPareja({ handler: ejecutarDesaprobar, accionLabel: 'desaprobación' }),
    [envolverConPareja, ejecutarDesaprobar]
  )
  
  
  // ============ RENDER ============
  
  // Mostrar error si hay
  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">
          <i className="bi bi-exclamation-triangle me-2"/>
          {error}
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* Cabecera con info OT y filtros */}
      {ots && (
        <Cabecera 
          ots={ots} 
          selectSede={setSedeSeleted} 
          sedeSeleted={sedeSeleted} 
          setSitioSeleted={setSitioSeleted} 
          setSedes={setSedes}
        />
      )}
      
      {/* Contadores/Indicadores */}
      <ContadoresOt ots={ots} />
      
      {/* Modal de carga */}
      <Modalcarga
        estadoIn={modalcharge} 
        cambiarestadoIn={SetModalcharge}
      >
        <Spinner />
      </Modalcarga>
      
      {/* Modales de acciones */}
      <Modales
        estado={estadomodal} 
        cambiarestado={setEstadomodal}
        titulo={`${accion.tarea} : ${accion.titulo}`}
      >
        <div>
          {accion.tarea === 'Editar' && (
            <Editareq 
              infoOt={ots} 
              refrescar={toggleRefresh} 
              infoequipo={equipoinfo} 
              cambiarestado={setEstadomodal} 
              setEquiposOtIni={setEquiposOtIni}
            />
          )}
          
          {accion.tarea === 'Cancelar' && (
            <Canceleq 
              infoOt={ots} 
              cambiarestado={setEstadomodal} 
              iditem={equipoinfo._id} 
              setEquiposOtIni={setEquiposOtIni} 
              setRefresh={toggleRefresh}
            />
          )}
          
          {accion.tarea === 'Editar Cliente' && (
            <Otdatacliente 
              infocliente={ots.cliente} 
              cambiarestado={setEstadomodal} 
              refrescar={toggleRefresh}
            />
          )}
          
          {accion.tarea === 'Hoja de Trabajo' && (
            <Otsonpdf  
              cambiarestado={setEstadomodal} 
              sitioSeleted={sitioSeleted} 
              setRefresh={toggleRefresh} 
              otFath={ots} 
              EqSedeFilter={EqSedeFilter}
              sedeSeleted={sedeSeleted}
              sedes={sedes}
            />
          )}
          
          {accion.tarea === 'Observacion' && (
            <Observacioneq 
              cambiarestado={setEstadomodal} 
              infoobservacion={equipoinfo?.observacion} 
            />
          )}
          
          {accion.tarea === 'Adicionar Ítems' && (
            <AgregarEquiposOt 
              ot={ots} 
              setEstadoModal={setEstadomodal} 
              setRefresh={toggleRefresh} 
              sedes={sedes} 
              sedeSeleted={sedeSeleted} 
              historialeq={historialeq} 
              setHistorialEq={setHistorialEq}
            />
          )}
          
          {accion.tarea === 'Hojas de Trabajo' && (
            <HojasDeTrabajo
              setEstadoModal={setEstadomodal}
              orden={ots.numeroOrden}
              setRefresh={toggleRefresh}
            />
          )}

          {accion.tarea === 'Hojas Emitidas' && (
            <HojasTrabajoList otId={ots?._id} refreshToken={ots?.avance || 0} />
          )}
          
          {accion.tarea === 'Equipos Finalizados' && (
            <EqFinalizadosTotal 
              setEstadoModal={setEstadomodal} 
              ot={ots}   
              setRefresh={toggleRefresh}
            />
          )}
        </div>
      </Modales>
      <br/>
      
      {/* Toolbar con acciones principales */}
      <ToolbarActionsResponsive
        task={task}
        onCreateHT={creteOt}
        onAprobar={handleAprobarSeleccion}
        onOpenHT={handleHT}
        onAddItems={handleAddEquipment}
        onExport={() => DateProgram(ots)}
        onGasto={handleGasto}
        onConfirmarPrestamo={handleConfirmarPrestamo}
        onSalidaEntrega={handleAbrirSalidaPatrones}
        equiposSeleccionados={equiSelectRef.current.length}
      />
      
      {/* Banner: sin visita vigente */}
      {task === 'finalizar' && visitaVigente === null && (
        <div className="alert alert-warning d-flex align-items-center justify-content-between mb-2" role="alert">
          <span><i className="bi bi-calendar-x me-2"/>No hay visita vigente para esta OT. No se pueden procesar equipos hasta reprogramar.</span>
          <button className="btn btn-warning btn-sm" onClick={() => setShowReprogramar(true)}>Reprogramar</button>
        </div>
      )}

      {/* Tabla de equipos */}
      <div className='detalle'>
        {!optionAproved ? (
          EqSedeFilter?.length > 0 ? (
          <TableEquiposCompact
              equipos={EqSedeFilter}
              task={task}
              currentUser={result}
              onEdit={Editequipo}
              onCancel={Cancelareq}
              onObserv={observacion}
              onFinalize={Finalizar}
              onActivate={Activar}
              onNoFinalize={NoFinalizar}
              equiSelectRef={equiSelectRef}
              selectAll={selectAll}
              onSelectAllChange={AprobarAllCheck}
              onAprovarOneToggle={AprobarOneCheck}
              onDesaprovar={handleDesaprobar}
              patronIdsActivos={patronIdsActivos}
              hayVisitaVigente={visitaVigente !== null}
            />
          ) : (
            <div className='alert alert-warning text-center'>
              <i className="bi bi-inbox me-2"/>
              <h5>No hay equipos para {task === 'finalizar' ? 'finalizar' : 'revisar'}</h5>
              {task === 'finalizar' && (
                <p className="mb-0">
                  Verifica que todos los equipos estén finalizados/cancelados. 
                  Si es así, descarga la Hoja de Trabajo en Seguimiento.
                </p>
              )}
            </div>
          )
        ) : null}
      </div>
      
      {/* Modal Hojas de Trabajo (cuando optionAproved='Htrabajo') */}
      {optionAproved === 'Htrabajo' && (
        <HojasTrabajo 
          Orden={ots?.numeroOrden} 
          SetModalcharge={SetModalcharge} 
          setRefresh={toggleRefresh}
        />
      )}
      
      {onGastoModal && bolsilloMio && (
        <ModalRegistrarMovimiento
          show={onGastoModal}
          onClose={() => setOnGastoModal(false)}
          onSuccess={() => setOnGastoModal(false)}
          bolsillo={bolsilloMio}
          otDefault={ots?._id ? {
            _id: ots._id,
            numeroOrden: ots.numeroOrden,
            cliente: ots.cliente || null
          } : null}
        />
      )}
      
      {/* Modal de Confirmar Préstamo/Entrega */}
      {mostrarModalConfirmar && (
        <ModalConfirmarEntrega
          show={mostrarModalConfirmar}
          onHide={handleCloseConfirmar}
          ot={ots}
          onSuccess={handleCloseConfirmar}
        />
      )}
      
      {/* Modal Nueva Salida de Patrones */}
      <Modal
        show={mostrarModalSalidaEntrada}
        onHide={handleCloseSalidaEntrada}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>📦 Registrar Salida de Patrones</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          <NuevaSalida
            onBack={handleCloseSalidaEntrada}
            onSuccess={(data) => {
              handleCloseSalidaEntrada();
            }}
            otDefault={ots ? {
              _id: ots._id,
              numeroOrden: ots.numeroOrden || '',
              cliente: ots.clientInformation?.nombre || '',
              ciudad: ots.clientInformation?.ciudad || ''
            } : null}
            equiposOt={EqSedeFilter}
          />
        </Modal.Body>
      </Modal>
      
      {/* Modal Detalle de Movimiento Activo */}
      <Modal
        show={mostrarModalDetalle}
        onHide={handleCloseDetalle}
        size="xl"
        centered
        scrollable
      >
        <Modal.Body style={{ padding: 0 }}>
          {movimientoDetalleData && (
            <DetalleMovimiento
              groupConsecutive={movimientoDetalleData.groupConsecutive}
              movimientoId={movimientoDetalleData._id}
              onBack={handleCloseDetalle}
              onRefresh={() => {}}
            />
          )}
        </Modal.Body>
      </Modal>
      
      {/* Modal de Hojas de Trabajo */}
      <ModalHojasTrabajo
        show={showModalHT}
        onHide={() => setShowModalHT(false)}
        numeroOrden={ots?.numeroOrden}
        cache={cacheHT}
        setCache={setCacheHT}
        onRefresh={toggleRefresh}
      />

      {/* Modal Reprogramar visita */}
      <ModalReprogramar
        show={showReprogramar}
        onClose={() => setShowReprogramar(false)}
        onSuccess={() => { setShowReprogramar(false); fetchVisitaVigente(); }}
        entidad="ot"
        idEntidad={ots?._id}
      />

      {/* Modal genérico de confirmación de acción sobre pareja padre↔hijos
          (spec items-adicionales-equipo-dependiente / sincronizacion-cancelacion). */}
      {modalAccionParejaProps.show && (
        <ModalConfirmarAccionPareja {...modalAccionParejaProps} />
      )}
    </div>
  )
}







